import * as React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const FileViewTable = ({items, readonly = false, onDeleteConfirm, textAlign}) => {

    const handleOnDeleteConfirm = (event, dataattachment, index) => {
        if(typeof onDeleteConfirm === 'function')
        {
            onDeleteConfirm(event, dataattachment, index)
        }
    }

    return <Table className="sp-table table rrs-table">
    <TableHead>
      <TableRow
        className="sp-table-header"
        style={{ backgroundColor: "#0072BC" }}
      >
        <TableCell
          className="th-table text-center"
          style={{ color: "#FFFFFF" }}
        >
          No.
        </TableCell>
        <TableCell
          className="th-table text-center"
          style={{ color: "#FFFFFF" }}
        >
          ชื่อเอกสารแนบ
        </TableCell>
        <TableCell
          className="th-table text-center"
          style={{ color: "#FFFFFF" }}
        >
          คำอธิบาย
        </TableCell>
        { readonly === false && <TableCell
          className="th-table text-center"
          style={{ color: "#FFFFFF" }}
        >
          ลบ
        </TableCell>}
        <TableCell
          className="th-table text-center"
          style={{ color: "#FFFFFF" }}
        >
          แสดง
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {items ? (
        items.filter((f) => f.isActive === true)
          .map((dataattachment, index) => {
            return (
              <TableRow key={index}>
                <TableCell
                  className={textAlign ? textAlign : "text-left"}
                  style={{ width: "10%" }}
                >
                  {index + 1}
                </TableCell>
                <TableCell
                  className={textAlign ? textAlign : "text-left"}
                  style={{ width: "25%" }}
                >
                  {dataattachment.file_name}
                </TableCell>
                <TableCell className={textAlign ? textAlign : "text-left"}>
                  {dataattachment.file_description}
                </TableCell>

                { readonly === false && <TableCell
                  className="text-center"
                  style={{ width: "10%" }}
                >
                  <a
                    onClick={(event) =>
                        handleOnDeleteConfirm(event, dataattachment, index)
                    }
                  >
                    <i className="icon btn-minus" />
                  </a>
                </TableCell>}

                <TableCell
                  className={textAlign ? textAlign : "text-left"}
                  style={{ width: "10%" }}
                >
                  <a href={dataattachment.file_url} target="_blank">
                    <i className="icon icon-preview-eye-blue" />
                  </a>
                </TableCell>
              </TableRow>
            );
          })
      ) : (
        <TableRow key={0}>
          <TableCell
            colSpan={readonly === true ? 10 : 11}
            className="text-center"
            style={{
              textAlign: "center",
              fontStyle: "italic",
              color: "gray",
            }}
          >
            No data
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
}

export default FileViewTable;